import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppContext } from '@/context/AppContext';
import FieldGroup from '@/components/FieldGroup';
import SectionTitle from '@/components/SectionTitle';
import Card from '@/components/Card';
import { FiArrowRight } from 'react-icons/fi';

function Step5BusinessSEO() {
  const { projectDraft, dispatch } = useAppContext();
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    dispatch({ type: 'UPDATE_PROJECT_DRAFT', payload: { [name]: value } });
  };
  
  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    dispatch({ type: 'UPDATE_PROJECT_DRAFT', payload: { [name]: checked } });
  };

  return (
    <div>
      <SectionTitle title="Step 5: Business & SEO" subtitle="Provide your business details and SEO preferences." />
      <div className="space-y-6">
        <FieldGroup label="Company Name">
          <input type="text" name="companyName" value={projectDraft.companyName || ''} onChange={handleChange} className="mt-1 block w-full rounded-md border-gray-300 shadow-sm" />
        </FieldGroup>
        <FieldGroup label="Business Email">
          <input type="email" name="businessEmail" value={projectDraft.businessEmail || ''} onChange={handleChange} className="mt-1 block w-full rounded-md border-gray-300 shadow-sm" />
        </FieldGroup>
        <FieldGroup label="SEO Keywords (comma-separated)">
          <textarea name="seoKeywords" value={projectDraft.seoKeywords || ''} onChange={handleChange} rows={3} className="mt-1 block w-full rounded-md border-gray-300 shadow-sm" />
        </FieldGroup>
        <div className="flex items-center">
          <input type="checkbox" name="hideFromSearch" id="hideFromSearch" checked={projectDraft.hideFromSearch || false} onChange={handleCheckboxChange} className="h-4 w-4 text-indigo-600 border-gray-300 rounded" />
          <label htmlFor="hideFromSearch" className="ml-2 block text-sm text-gray-900">Hide from Search Engines</label>
        </div>
      </div>

      <Card className="mt-8 bg-gray-50 border border-gray-200">
        <h3 className="font-bold text-lg text-gray-800">Next Steps</h3>
        <p className="text-sm text-gray-600 mt-2">Use the Setup Guides to configure GitHub, NCB, Cloudflare, Dropbox and OpenAI step-by-step.</p>
        <button
          onClick={() => navigate('/setup-guides')}
          className="mt-4 inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700"
        >
          Open Setup Guides <FiArrowRight className="ml-2" />
        </button>
      </Card>
    </div>
  );
}

export default Step5BusinessSEO;